module.exports = __webpack_public_path__ + "img/serifnew_box28.7a84797b.jpg";